import { render } from "./SiKaoView.vue?vue&type=template&id=7c2e08e3&scoped=true&ts=true"
import script from "./SiKaoView.vue?vue&type=script&lang=ts"
export * from "./SiKaoView.vue?vue&type=script&lang=ts"

import "./SiKaoView.vue?vue&type=style&index=0&id=7c2e08e3&lang=scss&scoped=true"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c2e08e3"]])

export default __exports__